import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Riwayat from './pages/Riwayat';
import Beranda from './pages/Beranda';
import TentangKami from './pages/TentangKami'; // 1. TAMBAHKAN IMPORT INI

function App() {
  const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true';

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        
        <Route 
          path="/beranda" 
          element={isAuthenticated ? <Beranda /> : <Navigate to="/" />} 
        />
        
        <Route 
          path="/dashboard" 
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />} 
        />

        <Route 
          path="/riwayat" 
          element={isAuthenticated ? <Riwayat /> : <Navigate to="/" />} 
        />

        {/* 2. DAFTARKAN RUTE TENTANG KAMI DI SINI */}
        <Route 
          path="/tentangkami" 
          element={isAuthenticated ? <TentangKami /> : <Navigate to="/" />} 
        />

        {/* Jika path tidak ditemukan, akan kembali ke Login */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;